import React from "react";
import "./css/Faq.css";
import { Container } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Faq() {
  const FAQs = [
    {
      title: "What's Malware detection System?",
      text: "Malware detection system is a service which helps to detects malicious malware with real time protection along with deep scan and ram booster.",
    },
    {
      title: "Do I need to setup account with you?",
      text: "You just need to setup account while purchasing the service. It is only needed for paid service.",
    },
    {
      title: "Is it a some kind of breaching someone's privacy?",
      text: "We care about your security and privacy and thus we want to ensure it, and that's why we created a platform where we can implement these, but don't breach someone's privacy or security, it is just a platform and collects no data.",
    },
    {
      title: "How do I avail your service?",
      text: "Visit Pricing page and avail offer whichever suits you.",
    },
    {
      title: "How to contact you?",
      text: "You can mail us at batch23.dev@gmail.com, we regularly check our mail and repond as soon as possible.",
    },
  ];
  return (
    <div >
      <Container maxWidth="sm">
        <center>
          <h3
            style={{
              color: "#035397",
              fontWeight: 700,
              textAlign: "center",
              width: "100%",
              padding: "10%",
            }}
          >
            Frequently Asked Questions
          </h3>
        </center>
        <br />
        <div>
          {FAQs.map((oneFAQ, index) => {
            return (
              <Accordion
                square={true}
                defaultExpanded={true}
                key={index}
                sx={{
                  color: "#0E185F",
                  borderBottom: "1px solid white",
                }}
                style={{borderRadius: "25px"}}
              >
                <AccordionSummary
                  style={{ backgroundColor: "#42C2FF80" }}
                  expandIcon={<ExpandMoreIcon sx={{ color: "#0E185F" }} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    sx={{
                      color: "#0E185F",
                      fontWeight: 500,
                      fontSize: "1.15rem",
                    }}
                  >
                    {oneFAQ.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ backgroundColor: "#42C2FF50" }}>
                  <Typography
                    sx={{
                      textAlign: "left",
                      color: "#0E185F",
                      fontWeight: 450,
                      fontSize: "1.05rem",
                    }}
                  >
                    {oneFAQ.text}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </Container>
    </div>
  );
}
